import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgInfoHollowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 110 20 10 10 0 010-20zm1.09 7.56h-2.15v8.24h2.15V9.56zm-1.1-3.36a1.25 1.25 0 00-1.24 1.25c0 .64.53 1.23 1.25 1.23a1.25 1.25 0 001.26-1.23c0-.66-.53-1.25-1.26-1.25z",
    fill: "#0397D8"
  })));
}

export { SvgInfoHollowIcon as S };
